// ############################################################
/**
 * @todo Document this
 */
// ############################################################

import { createContext } from 'react'

export const SignupStages = createContext<Array<any>>([])
